import { useId } from 'react';

export const IconLinkedin = ({
  width = 40,
  height = 40,
  color = 'var(--violet)',
}) => {
  const clipId = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='40' height='40' rx='20' fill={color} />
      <g clipPath={`url(#${clipId})`}>
        <path
          fill='#FAFAFC'
          d='M28.41 10H11.47c-.19 0-.38.03-.56.1a1.62 1.62 0 0 0-.47.31c-.14.13-.25.29-.32.46a1.66 1.66 0 0 0-.12.55v17.14c0 .19.04.38.12.55.07.17.18.33.32.46.13.13.29.24.47.31.18.07.37.1.56.1h16.94c.19 0 .38-.03.56-.1a1.6 1.6 0 0 0 .47-.31c.14-.13.25-.29.32-.46a1.6 1.6 0 0 0 .12-.55V11.43a1.6 1.6 0 0 0-.12-.55 1.61 1.61 0 0 0-.32-.46 1.6 1.6 0 0 0-.47-.31c-.18-.07-.37-.1-.56-.1ZM16.03 26.74h-3v-9h3v9Zm-1.5-10.26a1.56 1.56 0 0 1 0-3.12 1.56 1.56 0 0 1 0 3.12Zm12.32 10.26h-3v-4.83c0-1.21-.43-2-1.52-2a2.09 2.09 0 0 0-1.94 1.29 2.14 2.14 0 0 0-.19.87v4.67h-3V17.73h3v1.27a3.57 3.57 0 0 1 3.14-1.5c2 0 3.45 1.29 3.45 4.06v5.18Z'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect x='10' y='10' width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

// New Facebook icon for signup/login pages
